import { createContext, useContext } from 'react';
import { EditGroupMode } from '@models/CategoryLeaderboard';
import { FeatureOption } from '@utils/pageConfig/Types';

export interface CategoryOrSegmentLeaderboardGroupType {
  selectedProductGroupOrSegments: string[];
  selectProductGroupOrSegments: (pg: string) => void;
  clearSelectedPgsOrSegments: () => void;
  setSelectedPgsOrSegments: (pg: string[]) => void;
  isProductGroupOrSegmentsSelected: (pg: string) => boolean;
  isCreateModalGroupPopUp: boolean;
  setIsCreateModalGroupPopUp: (value: boolean) => void;
  groupNameToBeDelete: string;
  setGroupNameToBeDelete: (groupName: string) => void;
  isDeleteModalGroupPopUp: boolean;
  setIsDeleteModalGroupPopUp: (value: boolean) => void;
  isShareModalGroupPopUp: boolean;
  setIsShareModalGroupPopUp: (value: boolean) => void;
  isEditGroupMode: EditGroupMode;
  setIsEditGroupMode: (editGroup: EditGroupMode) => void;
  resetGroupingState: () => void;
  currentSelectedFeature: FeatureOption;
  setCurrentSelectedFeature: (featureOption: FeatureOption) => void;
}

export const CategoryOrSegmentsLeaderboardGroupContext = createContext<CategoryOrSegmentLeaderboardGroupType>(
  {} as CategoryOrSegmentLeaderboardGroupType,
);

export const useCategoryOrSegmentsLeaderboardGroupEventState = (): CategoryOrSegmentLeaderboardGroupType => {
  return useContext(CategoryOrSegmentsLeaderboardGroupContext);
};
